// Marketing copy and layout from the supplied website reference.
export function AboutContent() {
  return <>
    <section className="r-about-hero">
      <div className="r-about-hero-glow" aria-hidden="true" />
      <div className="r-wrap r-about-hero-inner">
        <img className="r-about-logo" alt="ISOPLEX INTELLIGENCE 壹索智能" width="680" height="209" src="/design-refresh/isoplex-logo-light.png" />
        <h1>
          <span lang="en">Co-evolve.</span>
          <span>共进化。</span>
        </h1>
        <p className="r-lead">壹索智能是一家科学智能企业，开拓科学智能的共进化范式。</p>
      </div>
    </section>
    <section id="vision" className="r-about-block">
      <div className="r-wrap r-about-center">
        <h2>
          <span className="r-nb">科学塑造智能，</span>
          <span className="r-nb">智能拓展科学。</span>
        </h2>
        <p>我们让智能不断发展自主开展科学研究的能力，并在科学知识、研究方法与真实证据中持续学习；智能形成的新认识与方法，也进一步拓展人类能够开展的科学研究。</p>
      </div>
    </section>
    <section id="products" className="r-about-block" aria-labelledby="systems-title">
      <div id="technology" className="r-wrap">
        <div className="r-about-center">
          <h2 id="systems-title">
            <span className="r-nb">三套体系，</span>
            <span className="r-nb">一条研发路径。</span>
          </h2>
        </div>
        <div className="r-systems">
          <article>
            <h3 lang="en">Iso-SWM</h3>
            <p className="r-sys-kind">科学世界模型</p>
            <p>研究科学对象的状态、变化与干预条件。</p>
          </article>
          <div className="r-sys-arrow" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" />
            </svg>
          </div>
          <article className="r-is-product">
            <h3 lang="en">Sciland</h3>
            <p className="r-sys-kind">科研工作空间</p>
            <p>组织研究过程，连接模型、计算与实验反馈。</p>
          </article>
          <div className="r-sys-arrow" aria-hidden="true">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 256 256">
              <path d="M221.66,133.66l-72,72a8,8,0,0,1-11.32-11.32L196.69,136H40a8,8,0,0,1,0-16H196.69L138.34,61.66a8,8,0,0,1,11.32-11.32l72,72A8,8,0,0,1,221.66,133.66Z" />
            </svg>
          </div>
          <article>
            <h3 lang="en">Iso-LabOS</h3>
            <p className="r-sys-kind">实验与反馈体系</p>
            <p>连接真实实验，让测量回到研究判断。</p>
          </article>
        </div>
      </div>
    </section>
    <section className="r-about-block">
      <div className="r-wrap r-about-center">
        <h2>从复杂疾病出发。</h2>
        <p>我们从复杂疾病与生命科学出发，优先聚焦呼吸与肿瘤，连接计算预演、真实验证与结果反馈。</p>
        <p className="r-purpose">推动科学进步，服务人类长远发展。</p>
      </div>
    </section>
    <section id="careers" className="r-about-block r-about-cta">
      <div className="r-wrap r-about-center">
        <h2>
          <span className="r-nb">与壹索一起，</span>
          <span className="r-nb">推进下一项研究。</span>
        </h2>
        <div className="r-about-actions">
          <a className="r-button r-primary" href="/enterprise">合作机会</a>
          <a className="r-button" href="/download#contact">联系团队</a>
        </div>
      </div>
    </section>
  </>;
}
export function ScenarioContent() {
  return <section className="r-section-tight">
    <div className="r-wrap">
      <ul className="r-scenario-list">
        <li>
          <h2>设计与验证分子候选</h2>
          <p className="r-scenario-when">已有靶点结构或序列，希望把设计推进到实验验证。</p>
          <dl>
            <div>
              <dt>从这里开始</dt>
              <dd>模型 · 工作流，湿实验</dd>
            </div>
            <div>
              <dt>Sciland 怎样参与</dt>
              <dd>运行官方工作流生成与比较候选；按研究问题选择表达、结合、亲和力、稳定性或荧光实验；实测结果回到原研究，修订下一轮方案。</dd>
            </div>
            <div>
              <dt>你会得到</dt>
              <dd>候选与评分依据、实验需求、预测与实测对照、下一轮方案</dd>
            </div>
          </dl>
        </li>
        <li>
          <h2>探索一个新课题</h2>
          <p className="r-scenario-when">有一个初步想法，需要弄清已有证据与研究价值。</p>
          <dl>
            <div>
              <dt>从这里开始</dt>
              <dd>研究，研究设计</dd>
            </div>
            <div>
              <dt>Sciland 怎样参与</dt>
              <dd>带入背景与目标，检索并比较文献中的发现、方法与相反证据，判断问题的新意，形成可行的研究设计。</dd>
            </div>
            <div>
              <dt>你会得到</dt>
              <dd>带来源的证据整理、研究设计与分析计划</dd>
            </div>
          </dl>
        </li>
        <li>
          <h2>深入一组已有数据</h2>
          <p className="r-scenario-when">数据已经在手，希望知道它能回答什么问题。</p>
          <dl>
            <div>
              <dt>从这里开始</dt>
              <dd>研究，源数据文件夹</dd>
            </div>
            <div>
              <dt>Sciland 怎样参与</dt>
              <dd>检查样本、变量与数据质量，制定分析方案，运行 Python、R 完成分析与制图，由独立审查核对结果。</dd>
            </div>
            <div>
              <dt>你会得到</dt>
              <dd>数据检查说明、分析代码、结果表与科研图表、审查意见</dd>
            </div>
          </dl>
        </li>
        <li>
          <h2>整理一项研究成果</h2>
          <p className="r-scenario-when">已有分析与发现，需要组织成清楚、连贯的材料。</p>
          <dl>
            <div>
              <dt>从这里开始</dt>
              <dd>研究，报告预览与标注</dd>
            </div>
            <div>
              <dt>Sciland 怎样参与</dt>
              <dd>整合结果、图表与引用，形成报告或论文草稿；在正文和图上标注修改意见，核对证据与表述是否一致。</dd>
            </div>
            <div>
              <dt>你会得到</dt>
              <dd>研究报告与草稿（可导出 PDF）、修订记录</dd>
            </div>
          </dl>
        </li>
      </ul>
      <aside className="r-scope-note">
        <h2>从生物医学出发，向更多研究问题拓展。</h2>
        <p>生物医学是 Sciland 当前重点优化的领域。具体任务能做到哪一步，取决于数据、方法、技能与计算环境。欢迎带着你的研究场景与我们交流。</p>
        <a className="r-text-link" href="/enterprise">
          <span>交流你的研究场景</span>
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 256 256" aria-hidden="true">
            <path d="M224.49,136.49l-72,72a12,12,0,0,1-17-17L187,140H40a12,12,0,0,1,0-24H187L135.51,64.48a12,12,0,0,1,17-17l72,72A12,12,0,0,1,224.49,136.49Z" />
          </svg>
        </a>
      </aside>
    </div>
  </section>;
}
export function PartnershipContent() {
  return <section className="r-section-tight">
    <div className="r-wrap">
      <ul className="r-partner-list">
        <li>
          <h2>研究团队</h2>
          <dl>
            <div>
              <dt>带来</dt>
              <dd>研究问题、数据条件或现有流程</dd>
            </div>
            <div>
              <dt>一起讨论</dt>
              <dd>Sciland 适合从哪个环节加入，计算与审查怎样嵌入团队的研究方式。</dd>
            </div>
          </dl>
        </li>
        <li>
          <h2>实验室</h2>
          <dl>
            <div>
              <dt>带来</dt>
              <dd>既有设备、实验协议与数据流程</dd>
            </div>
            <div>
              <dt>一起讨论</dt>
              <dd>实验需求、样品要求、结果交付与反馈，怎样与计算方案衔接。</dd>
            </div>
          </dl>
        </li>
        <li>
          <h2>模型与工具伙伴</h2>
          <dl>
            <div>
              <dt>带来</dt>
              <dd>科学模型、分析工具或计算环境</dd>
            </div>
            <div>
              <dt>一起讨论</dt>
              <dd>能力怎样进入可复用的科研工作流，由研究负责人组织调用。</dd>
            </div>
          </dl>
        </li>
      </ul>
      <div className="r-setup">
        <h2>合作怎样开始</h2>
        <ol>
          <li>
            <span>1</span>
            <div>
              <strong>联系团队</strong>
              <p>通过邮件或电话，简要说明研究方向与合作意向。</p>
            </div>
          </li>
          <li>
            <span>2</span>
            <div>
              <strong>交流目标与材料</strong>
              <p>研究目标、已有数据、验证需求与时间安排。</p>
            </div>
          </li>
          <li>
            <span>3</span>
            <div>
              <strong>确定合作方式</strong>
              <p>明确适用环节、交付内容与各方分工，再开始工作。</p>
            </div>
          </li>
        </ol>
      </div>
    </div>
  </section>;
}
